import { MAINTENANCE_TYPE_ADD, } from '../app-constants';

export function validateForm(uiFieldInfo, dataObject, maintenanceType) {
    const errors = [];
    const info = [];
    let valid = true;

    uiFieldInfo.map((fld) => {

        if (maintenanceType === MAINTENANCE_TYPE_ADD && !fld.showOnAdd)
            return '';

        if (maintenanceType !== MAINTENANCE_TYPE_ADD && !fld.updatable)
            return '';

        const fldValue = dataObject[fld.fieldName];

        //console.log('fieldName=' + fld.fieldName + ' required=' + fld.required + ' value=' + fldValue + '<EOD>');

        if (fld.required === 'true' && fldValue === '') {
            valid = false;
            errors.push(`  ** ${fld.displayTitle} is required!`);
        }

        const fieldInfo = buildFieldInfo(fld);

        switch (fld.editType) {
            case 'NumericWithDecimal': {
                if (!validateNumericWithDecimal(fldValue, fld)) {
                    valid = false;
                    errors.push(` ** ${fld.displayTitle} invalid ${fieldInfo}`)
                }

                break;
            }

            case 'NumericOnly': {
                if (!validateNumeric(fldValue, fld)) {
                    valid = false;
                    errors.push(` ** ${fld.displayTitle} invalid ${fieldInfo}`)
                }

                break;
            }

            case 'AlphaNumericSpacesOnly': {
                if (!validateAlphaNumericSpacesOnly(fldValue, fld)) {
                    valid = false;
                    errors.push(` ** ${fld.displayTitle} invalid ${fieldInfo}`)
                }

                break;
            }

            case 'AlphaSpacesOnly': {
                if (!validateAlphaSpacesOnly(fldValue, fld)) {
                    valid = false;
                    errors.push(` ** ${fld.displayTitle} invalid ${fieldInfo}`)
                }

                break;
            }

            case 'AlphaOnly': {
                if (!validateAlphaOnly(fldValue, fld)) {
                    valid = false;
                    errors.push(` ** ${fld.displayTitle} invalid ${fieldInfo}`)
                }

                break;
            }

            case 'DateMMDDYYYY': {
                if (fldValue !== '' || fld.required === 'true') {
                    if (!validateDateMMDDYYYY(fldValue, fld)) {
                        valid = false;
                        errors.push(` ** ${fld.displayTitle} Invalid Date (MM/DD/YYYY)`)
                    }
                }

                break;
            }

            case 'DateYYYYMMDD': {
                if (fldValue !== '' || fld.required === 'true') {
                    if (!validateDateYYYYMMDD(fldValue, fld)) {
                        valid = false;
                        errors.push(` ** ${fld.displayTitle} Invalid Date (YYYY-MM-DD)`)
                    }
                }

                break;
            }

            default:

        }

        return '';

    });

    if (valid)
        info.push('No validation errors\r\n');

    return {
        errors,
        info,
        valid,
    };
}

export function buildFieldInfo(fld) {
    let info = '( ' + fld.editType + ' ';


    if (fld.required)
        info += 'required ';

    if (fld.minimumValue !== '')
        info += 'minimum:' + fld.minimumValue + ' ';

    if (fld.maximumValue !== '')
        info += 'maximum:' + fld.maximumValue + ' ';

    if (fld.editType === 'NumericWithDecimal')
        info += ' decimal positions:' + fld.decimalPositions + ' ';

    info += ')';

    return info;

}

export function validateNumericWithDecimal(inputValue, fld) {
    let leftDigits = fld.maxLength - fld.decimalPositions - 1;

    const regex = new RegExp('^[0-9]{1,' + leftDigits + '}(?:.[0-9]{0,' + fld.decimalPositions + '})?$');

    if (!regex.test(inputValue))
        return false;

    if (parseFloat(inputValue) < parseFloat(fld.minimumValue))
        return false;

    if (parseFloat(inputValue) > parseFloat(fld.maximumValue))
        return false;

    return true;
}

export function validateNumeric(inputValue, fld) {
    let regex = new RegExp('^[0-9]{1,' + fld.maxLength + '}$');

    if (parseInt(fld.minimumValue) < 0 && parseInt(inputValue) < 0)
        regex = new RegExp('^-[0-9]{1,' + fld.maxLength + '}$');

    if (!regex.test(inputValue))
        return false;

    if (parseInt(inputValue) < parseInt(fld.minimumValue))
        return false;

    if (parseInt(inputValue) > parseInt(fld.maximumValue))
        return false;

    return true;
}

export function validateAlphaNumericSpacesOnly(inputValue) {
    const regex = new RegExp('^^[a-zA-Z0-9 ]*$');
    return regex.test(inputValue);

}

export function validateAlphaSpacesOnly(inputValue) {
    const regex = new RegExp('^^[a-zA-Z ]*$');
    return regex.test(inputValue);

}

export function validateAlphaOnly(inputValue) {
    const regex = new RegExp('^^[a-zA-Z]*$');
    return regex.test(inputValue);

}

export function validateDateMMDDYYYY(inputValue) {
    const regex = new RegExp('^[0-9]{2}/{1}[0-9]{2}/{1}[0-9]{4}$');

    if (!regex.test(inputValue))
        return false;

    const month = parseInt(inputValue.substring(0, 2));
    const day = parseInt(inputValue.substring(3, 5));
    const year = parseInt(inputValue.substring(6, 10));

    return validateDate(month, day, year);
}

export function validateDateYYYYMMDD(inputValue) {
    const regex = new RegExp('^[0-9]{4}-{1}[0-9]{2}-{1}[0-9]{2}$');

    if (!regex.test(inputValue))
        return false;

    const year = parseInt(inputValue.substring(0, 4));
    const month = parseInt(inputValue.substring(5, 7));
    const day = parseInt(inputValue.substring(8, 10));


    return validateDate(month, day, year);
}

export function validateDate(month, day, year) {
    if (month < 1 || month > 12)
        return false;

    if (year < 1900)
        return false;

    if (year > 2099)
        return false;

    let febdays = 28;

    if (year / 4 === parseInt(year / 4))
        febdays = 29;

    const daysInMonth = [31, febdays, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];

    if (day < 1 || day > daysInMonth[month - 1])
        return false;

    return true;
}

export function checkForChanges(uiFieldInfo, dataObject, originalDataObject) {

    let changes = false;

    uiFieldInfo.map((fld) => {

        const fldValue = dataObject[fld.fieldName];
        const originalFldValue = originalDataObject[fld.fieldName];

        if (fldValue !== originalFldValue)
            changes = true;

        return '';

    });

    return changes;
}
